/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SessionStatus = {
  Queued: "queued",
  Pending: "pending",
  Provisioning: "provisioning",
  Running: "running",
  Idle: "idle",
  Stopped: "stopped",
  Failed: "failed",
  Terminated: "terminated",
} as const;
export type SessionStatus = ClosedEnum<typeof SessionStatus>;

/** @internal */
export const SessionStatus$inboundSchema: z.ZodNativeEnum<
  typeof SessionStatus
> = z.nativeEnum(SessionStatus);
/** @internal */
export const SessionStatus$outboundSchema: z.ZodNativeEnum<
  typeof SessionStatus
> = SessionStatus$inboundSchema;
